import {
  getResourceScopedViewPermission,
  type ResourceScopedPermissionResourceType,
} from "api-types/builderUsers/builderUsersBaseTypes";
import type { ClientCedarPolicy } from "api-types/permissions/permissionsResponses";
import type { ClientUserHydrated } from "api-types/users/usersResponses";
import { WEB_API_BASE_PATH } from "common/constants";
import { getBuilderPoliciesURL } from "lib/endpointHelpers";
import { fetcher } from "lib/fetcher";

export type SalesStaffResourceType = ResourceScopedPermissionResourceType;

export function getSalesStaffResourceFilterUrl(args: {
  builderId: string;
  resourceType: SalesStaffResourceType;
  resourceId?: string | null;
}): string | null {
  if (!args.resourceId) {
    return null;
  }

  const filterPermission = getResourceScopedViewPermission(args.resourceType);
  const search = new URLSearchParams({
    permission: filterPermission,
    resourceType: args.resourceType,
    resourceId: args.resourceId,
  });

  return `${WEB_API_BASE_PATH}/builders/${args.builderId}/users-internal?${search.toString()}`;
}

export function getBuilderUserIdForBuilder(args: { user: ClientUserHydrated; builderId: string }): string | undefined {
  return args.user.builderAccounts.find((account) => account.builderId === args.builderId)?.id;
}

export async function grantSalesStaffResourceViewAccess(args: {
  builderId: string;
  targetUser: ClientUserHydrated;
  resourceType: SalesStaffResourceType;
  resourceId: string;
}): Promise<void> {
  const builderUserId = getBuilderUserIdForBuilder({ user: args.targetUser, builderId: args.builderId });
  if (!builderUserId) {
    throw new Error("Selected user is not a member of this builder");
  }

  const filterPermission = getResourceScopedViewPermission(args.resourceType);

  await fetcher<ClientCedarPolicy>(
    getBuilderPoliciesURL({ builderId: args.builderId }),
    true,
    {},
    {
      name: `sales-staff-resource-grant:${filterPermission}:${builderUserId}:${args.resourceId}`,
      effect: "PERMIT",
      actions: [filterPermission],
      resources: [args.resourceId],
      builderUserId,
    },
  );
}
